import { axiosInstance } from "../../../config/axios";
import endpoints from "../../../config/endpoints";
import { GenericResponse } from "../../../types";


export interface Email {
    id: number;
    created_at: string;
    updated_at: string;
    deleted_at: string;
    message_id: string;
    event_type: string;
    event_id: string;
    email: string;
    subject: string;
    text_body: string;
    from_email: string;
    to_email: string;
    email_message_id: string;
    in_reply_to: string;
    references: string;
    thread_id: string;
    is_outbound: boolean;
    replied_at: string;
    reply_status: string;
    raw_payload: {
    additionalProp1: Record<string, unknown>;
    }
}

export const getEmails = async (params: { page: number; limit: number }): Promise<GenericResponse<Email[]>> => {
    const response = await axiosInstance.get<GenericResponse<Email[]>>(
        `${import.meta.env.PROD ? endpoints().messaging.getEmails : `/api/v1${endpoints().messaging.getEmails}`}`,
        { params },
    );
    return response.data;
};

export const getEmailsByUserId = async (userId: number): Promise<GenericResponse<Email[]>> => {
    const response = await axiosInstance.get<GenericResponse<Email[]>>(
        `${import.meta.env.PROD ? endpoints(userId).messaging.getEmailsByUserId : `/api/v1${endpoints(userId).messaging.getEmailsByUserId}`}`,
    );
    return response.data;
};

export const downloadEmails = async (params: { user_id: number }): Promise<Blob> => {
    const response = await axiosInstance.get<Blob>(
        `${import.meta.env.PROD ? endpoints().messaging.downloadEmails : `/api/v1${endpoints().messaging.downloadEmails}`}`,
        {
            params,
            responseType: 'blob',
        },
    );
    return response.data;
};